const Loader = () => {
	return (
		<div className='flex justify-center items-center min-h-screen'>
			<svg
				width='140'
				height='200'
				viewBox='-1 -1 24 26'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				className='loader-svg'
			>
				<path
					d='M18.0047 6.56365C16.861 2.22705 12.6618 -0.492383 7.98281 0.072499C3.83085 0.574894 0.442151 4.43909 0.399885 8.74319C0.377509 10.9427 0.394912 13.1423 0.394912 15.3418H0.40237C0.40237 17.6338 0.387455 19.9234 0.412317 22.2154C0.419776 22.8528 0.188555 23.7151 1.01895 23.9575C1.79464 24.1825 2.16758 23.4276 2.55294 22.8927C3.6767 21.3356 4.79549 19.7734 5.88445 18.1912C6.21512 17.7113 6.5607 17.5889 7.11264 17.7463C7.9306 17.9813 8.77094 18.1287 9.63116 18.0837C15.526 17.7863 19.5163 12.2975 18.0022 6.56115L18.0047 6.56365ZM9.30049 14.532C8.17922 14.532 7.1375 14.1946 6.26484 13.6197C5.785 14.312 5.29771 14.9944 4.80544 15.6767C4.61897 15.9342 4.43997 16.2991 4.06455 16.1891C3.66427 16.0717 3.77615 15.6568 3.77118 15.3493C3.75875 14.2445 3.76621 13.1398 3.76621 12.035H3.76372C3.76372 11.0952 3.75875 10.1529 3.76372 9.2131C3.75875 9.12561 3.75129 9.04063 3.75129 8.95315C3.75129 5.87129 6.235 3.37431 9.30049 3.37431C12.366 3.37431 14.8497 5.87129 14.8497 8.95315C14.8497 12.035 12.366 14.532 9.30049 14.532Z'
					stroke='#FBB040'
					strokeWidth='2'
					strokeLinecap='round'
					strokeLinejoin='round'
					className='loader-path'
				/>
				<path
					d='M18.0047 6.56365C16.861 2.22705 12.6618 -0.492383 7.98281 0.072499C3.83085 0.574894 0.442151 4.43909 0.399885 8.74319C0.377509 10.9427 0.394912 13.1423 0.394912 15.3418H0.40237C0.40237 17.6338 0.387455 19.9234 0.412317 22.2154C0.419776 22.8528 0.188555 23.7151 1.01895 23.9575C1.79464 24.1825 2.16758 23.4276 2.55294 22.8927C3.6767 21.3356 4.79549 19.7734 5.88445 18.1912C6.21512 17.7113 6.5607 17.5889 7.11264 17.7463C7.9306 17.9813 8.77094 18.1287 9.63116 18.0837C15.526 17.7863 19.5163 12.2975 18.0022 6.56115L18.0047 6.56365ZM9.30049 14.532C8.17922 14.532 7.1375 14.1946 6.26484 13.6197C5.785 14.312 5.29771 14.9944 4.80544 15.6767C4.61897 15.9342 4.43997 16.2991 4.06455 16.1891C3.66427 16.0717 3.77615 15.6568 3.77118 15.3493C3.75875 14.2445 3.76621 13.1398 3.76621 12.035H3.76372C3.76372 11.0952 3.75875 10.1529 3.76372 9.2131C3.75875 9.12561 3.75129 9.04063 3.75129 8.95315C3.75129 5.87129 6.235 3.37431 9.30049 3.37431C12.366 3.37431 14.8497 5.87129 14.8497 8.95315C14.8497 12.035 12.366 14.532 9.30049 14.532Z'
					fill='#FBB040'
					className='loader-fill'
				/>
				<path
					d='M20.1726 17.8737C21.1818 17.8737 21.9999 17.0512 21.9999 16.0366C21.9999 15.022 21.1818 14.1995 20.1726 14.1995C19.1634 14.1995 18.3452 15.022 18.3452 16.0366C18.3452 17.0512 19.1634 17.8737 20.1726 17.8737Z'
					fill='#FBB040'
				/>
			</svg>
		</div>
	);
};

export default Loader;
